import { css } from "@emotion/react";
import { APP_SLUGS } from "utils/constants";

export const wowGamesStyles = css`
  &.${APP_SLUGS.WOW_GAMES} {
    .custom-page {
      padding-bottom: 5rem;
    }
    .random-games {
      &.btn {
        display: none;
      }
    }
    .rank-btn {
      background: #3e3a39 !important;
    }
    .profile-history-list {
      .prize-title,
      .prize-value {
        display: none;
      }
    }
    .history-container {
      .entry-fee {
        .label,
        .label-value,
        .tournament-type {
          display: none;
        }
      }
    }
  }
`;

export default wowGamesStyles;
